import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
  TextField,
} from "@mui/material";
import { mdiClose, mdiTrayArrowDown } from "@mdi/js";
import Icon from "@mdi/react";
import { useState } from "react";
import styles from "../reportSection.module.scss";

interface ReportDialogProps {
  open: boolean;
  onClose: () => void;
  inventories: { inventoryId: number; inventoryName: string; inventoryNumber: number }[];
  onDownload: (inventoryId: number) => void;
  title: string | null;
}

const ReportDialog: React.FC<ReportDialogProps> = ({
  open,
  onClose,
  inventories,
  onDownload,
  title,
}) => {
  const [search, setSearch] = useState("");

  const filtered = inventories.filter((inv) =>
    inv.inventoryName.toLowerCase().includes(search.toLowerCase())
  );

  return (
<Dialog
  open={open}
  onClose={onClose}
  fullWidth
  maxWidth="xs"
  sx={{
    "& .MuiDialog-paper": {
      maxHeight: "60vh",
      borderRadius: "12px", // optional: rounded
    },
  }}
>
  <DialogTitle>
    <div className={styles.dialogHeader}>
      <span className={styles.dialogTitle}>{title ?? "Download Report"}</span>
      <IconButton onClick={onClose} size="small">
        <Icon path={mdiClose} size={1} />
      </IconButton>
    </div>
  </DialogTitle>

  <DialogContent dividers sx={{ p: 0 }}>
    {inventories && inventories.length > 2 && (
      <div
        style={{
          position: "sticky",
          top: 0,
          background: "white",
          zIndex: 1,
          padding: "12px 16px",
          borderBottom: "1px solid #ddd",
        }}
      >
        <TextField
          fullWidth
          placeholder="Search inventory..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          size="small"
        />
      </div>
    )}

    <List disablePadding>
      {filtered.map((item, index) => (
        <div key={item.inventoryId}>
          <ListItem
            secondaryAction={
              <IconButton onClick={() => onDownload(item.inventoryId)} size="small">
                <Icon path={mdiTrayArrowDown} size={0.85} />
              </IconButton>
            }
          >
            <ListItemText
              primary={item.inventoryName}
              secondary={`#${item.inventoryNumber}`}
            />
          </ListItem>
          {index < filtered.length - 1 && <Divider />}
        </div>
      ))}
    </List>
  </DialogContent>
</Dialog>

  );
};

export default ReportDialog;
